import React, { Component } from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux";

// actions
import { getProcessos } from "../../store/actions";

class Demo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      demo: []
    };
  };
  componentDidMount() {
    const { onGetDemoData } = this.props;
    onGetDemoData();
  };

  //get Data
  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({ ...this.state, demo: this.props.demoData });
    }
  };
  render() {
    console.log(this.state.demo);
    return (
      <div>
      </div>
    );
  };
};

Demo.propTypes = {
  demoData: PropTypes.any,
  onGetDemoData: PropTypes.func
};

const mapStateToProps = ({ Demo }) => ({
  demoData: Demo.demoData,
});

const mapDispatchToProps = dispatch => ({
  onGetDemoData: () => dispatch(getProcessos()),
});

export default connect(
  mapStateToProps, mapDispatchToProps
)(Demo);